import { Injectable, inject } from '@angular/core';

import {
  ErrorModalComponent,
  ErrorModalData,
  ModalService,
  UserRightsService,
} from '@schenck/rotec-components';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { UserRole } from 'src/enums/user.enum';
import { ServerErrorService } from '../server-error/server-error.service';

/**
 * The guard that allows to access the application
 */
@Injectable({ providedIn: 'root' })
export class AppGuard {
  private readonly userRightService = inject(UserRightsService);
  private readonly modalService = inject(ModalService);
  private readonly serverErrorService = inject(ServerErrorService);

  canActivate(): Observable<boolean> {
    return this.userRightService.userRole$.pipe(
      filter((role) => !!role),
      map((role) => role === UserRole.Admin || role === UserRole.RoTec),
      switchMap((hasAccess) => {
        if (!hasAccess) {
          return this.userRightService.stateError$;
        } else {
          return of(null);
        }
      }),
      map((hasStateError) => {
        if (hasStateError !== null && hasStateError === false) {
          this.modalService.open(ErrorModalComponent, <ErrorModalData>{
            text: 'You are not authorized to access this page.',
            title: 'COMMON_Error',
          });

          return false;
        } else {
          this.serverErrorService.setAppError(hasStateError);
          return true;
        }
      })
    );
  }
}
